import * as Api from '@ViewModels';
import { Query, useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'SystemJob/<id>';

export function useGetSystemJobQuery<TSystemJob extends Api.ISystemJob = Api.ISystemJob>({
	enabled,
	jobId,
	refetchOnWindowFocus = false,
	refetchInterval,
}: {
	enabled: boolean;
	jobId: string;
	refetchInterval?:
		| number
		| false
		| ((query: Query<TSystemJob, Error, TSystemJob, string[]>) => number | false | undefined);
	refetchOnWindowFocus?: boolean;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<TSystemJob>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `SystemJob/${jobId}` }),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, jobId],
		refetchInterval,
		refetchOnWindowFocus,
	});
}
